export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["इनपुट:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जारी रखें"])}
}